import { useEffect, useRef } from "react";

export default function AmbientLight() {
  const lightRef = useRef(null);
  const targetRef = useRef({ x: -500, y: -500 });
  const posRef = useRef({ x: -500, y: -500 });

  useEffect(() => {
    if (window.innerWidth < 1024) return;

    const onMove = (e) => {
      targetRef.current = { x: e.clientX, y: e.clientY };
    };
    window.addEventListener("mousemove", onMove, { passive: true });

    let raf;
    const loop = () => {
      posRef.current.x += (targetRef.current.x - posRef.current.x) * 0.055;
      posRef.current.y += (targetRef.current.y - posRef.current.y) * 0.055;
      if (lightRef.current) {
        lightRef.current.style.transform = `translate3d(${posRef.current.x - 320}px, ${posRef.current.y - 320}px, 0)`;
      }
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      ref={lightRef}
      aria-hidden="true"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: 640,
        height: 640,
        borderRadius: "50%",
        background:
          "radial-gradient(circle, rgba(200,121,65,0.042) 0%, rgba(200,121,65,0.018) 35%, transparent 70%)",
        filter: "blur(50px)",
        pointerEvents: "none",
        zIndex: 50,
        willChange: "transform",
        mixBlendMode: "screen",
      }}
    />
  );
}
